import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import Axios from "axios";
import FormHelper from "@Scripts/Common/FormHelper";
import Localizer from "@Scripts/Common/Localizer";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";

@Component({ name: "GlobalCatalogueCarSearch" })
export default class GlobalCatalogueCarSearch extends Vue {
    public localizer: any = Localizer;
    public vehicleType: string = "Car";

    public formData: any = {
        type: { brandCode: null, modelYear: null, modelCode: null, typeCode: null, productTypes: ["All"] },
        plate: { country: null, plate: null },
        code: { code: null },
        size: { productType: "Disc", discSize: {}, drumSize: {} }
    };

    public brands: any[] = [];
    public years: any[] = [];
    public models: any[] = [];
    public types: any[] = [];
    public codes: any[] = [];

    public suggestionIndex: number = -1;
    public suggestionMode: string = null;
    public suggestions: any[] = [];

    public brandTitle: string = "";
    public yearTitle: string = "";
    public modelTitle: string = "";
    public typeTitle: string = "";
    public isReportCode: boolean = false;
    public isReported: boolean = false;
    public isProductTypeMenu: boolean = false;
    public selectedProductTypes: string = null;
    public isSearchPlateVisible: boolean = false;

    public aftermarketList: any[] = [];
    public upgradeList: any[] = [];
    public isSelectingAllAftermarket: boolean = true;
    public isSelectingAllUpgrade: boolean = true;

    public isLoadingPlate: boolean = false;
    public isPlateError: boolean = false;
    public isLoading: boolean = false;
    public validationErrors: any[] = [];

    @Prop() readonly region: string;
    @Prop() readonly culture: string;
    @Prop() readonly country: string;
    @Prop() readonly filter: any;
    @Prop() readonly plateCountries: any;
    @Prop() readonly searchCarProductTypes: any;
    @Prop() readonly isHome: boolean;
    @Prop() readonly isUserAuthenticated: boolean;
    @Prop() readonly searchMode: string;
    @Prop() readonly vehicleFilter: any;

    @Watch("searchMode") onSearchModeChanged(newValue: any) {
        this.validationErrors = [];
    }

    get routes() {
        return (<any>window).App.routes;
    }

    public async mounted() {
        if (this.filter.brandCode) {
            await this.getBrands();

            const brand = this.brands.find(x => x.brandCode === this.filter.brandCode);
            if (brand) {
                this.formData.type.brandCode = brand.brandCode;
                this.brandTitle = brand.title;
            }
        }

        if (this.region === "america" && this.filter.brandCode && this.filter.modelYear) {
            await this.getYears();

            const year = this.years.find(x => x.value === this.filter.modelYear);
            if (year) {
                this.formData.type.modelYear = year.value;
                this.yearTitle = year.title;
            }
        }

        if (this.region === "america" && this.filter.brandCode && this.filter.modelYear && this.filter.modelCode) {
            await this.getModels();

            const model = this.models.find(x => x.modelCode === this.filter.modelCode);
            if (model) {
                this.formData.type.modelCode = model.modelCode;
                this.modelTitle = model.title;
            }
        }

        if (this.region !== "america" && this.filter.brandCode && this.filter.modelCode) {
            await this.getModels();

            const model = this.models.find(x => x.modelCode === this.filter.modelCode);
            if (model) {
                this.formData.type.modelCode = model.modelCode;
                this.modelTitle = model.title;
            }
        }

        if (this.filter.brandCode && this.filter.modelCode && this.filter.typeCode) {
            await this.getTypes();

            const type = this.types.find(x => x.typeCode === this.filter.typeCode);
            if (type) {
                this.formData.type.typeCode = type.typeCode;
                this.typeTitle = type.title;
            }

            if (type && this.filter.productTypes.length >= 1) {
                this.formData.type.productTypes = this.filter.productTypes;
            }

            if (this.filter.vehicleType === "Car") {
                var brand = this.brands.find(x => x.value === this.formData.type.brandCode)?.title;
                var year = this.years.find(x => x.value === this.formData.type.modelYear)?.value;
                var model = this.models.find(x => x.value === this.formData.type.modelCode)?.modelName;
                var typesend = this.types.find(x => x.value === this.formData.type.typeCode)?.title;

                if (brand && model) {
                    (<any>this.$parent).setSearchBar({ title: brand + " " + model, subTitle: this.region === "america" ? year : typesend });
                }
            }
        }

        this.aftermarketList = this.searchCarProductTypes.filter(x => x.additionalValues[0].value === 'Aftermarket').map(function (item) { return item['value']; });
        this.upgradeList = this.searchCarProductTypes.filter(x => x.additionalValues[0].value === 'Upgrade').map(function (item) { return item['value']; });
        this.checkSelectionActive();
        this.setProductTypeLabel();

        if (this.filter.mode === "Code" && this.filter.code) {
            (<any>this.$parent).setSearchMode("Code");
            this.formData.code.code = this.filter.code;
        }

        if (this.filter.mode === "Size") {
            (<any>this.$parent).setSearchMode("Size");
            this.formData.size.productType = this.filter.productType;

            if (this.formData.size.productType === "Disc") {
                this.formData.size.discSize.diameter = this.filter.diameter?.toString();
                this.formData.size.discSize.th = this.filter.th?.toString();
                this.formData.size.discSize.a = this.filter.a?.toString();
                this.formData.size.discSize.minTH = this.filter.minTH?.toString();
                this.formData.size.discSize.isSizeTolerance = this.filter.isSizeTolerance;
            }

            if (this.formData.size.productType === "Drum") {
                this.formData.size.drumSize.diameter = this.filter.diameter?.toString();
                this.formData.size.drumSize.c = this.filter.c?.toString();
                this.formData.size.drumSize.d = this.filter.d?.toString();
                this.formData.size.drumSize.isSizeTolerance = this.filter.isSizeTolerance;
            }
        }

        if (this.plateCountries.some(x => x.value === this.country) || this.country === "GB") {
            this.isSearchPlateVisible = true;
            this.country === "GB" ? this.formData.plate.country = "UK" : this.formData.plate.country = this.country;
        }

        this.syncFilterData();
    }

    public async getBrands() {
        this.brands = (await Axios.post(this.routes.CatalogueGlobalCarSearch_GetSearchBrands, { vehicleType: this.vehicleType })).data;
    }

    public async getYears() {
        this.years = (await Axios.post(this.routes.CatalogueGlobalCarSearch_GetSearchYears, { brandCode: this.formData.type.brandCode, vehicleType: this.vehicleType })).data;
    }

    public async getModels() {
        this.models = (await Axios.post(this.routes.CatalogueGlobalCarSearch_GetSearchModels, { brandCode: this.formData.type.brandCode, vehicleType: this.vehicleType, modelYear: this.formData.type.modelYear })).data;
    }

    public async getTypes() {
        this.types = (await Axios.post(this.routes.CatalogueGlobalCarSearch_GetSearchTypes, { modelCode: this.formData.type.modelCode })).data;
    }

    public async getCodes() {
        this.codes = (await Axios.post(this.routes.CatalogueGlobalCarSearch_GetSearchCodeSuggestions, { codePrefix: this.formData.code.code })).data;
    }

    public async setBrandMenu() {
        if (this.brands.length === 0) {
            await this.getBrands();
        }

        this.resetSuggestionValues();
        this.suggestionMode = "Brand";

        this.formData.type.brandCode = null;

        if (this.brandTitle) {
            this.suggestions = this.brands.filter(x => x.title.toLowerCase().startsWith(this.brandTitle.toLowerCase()));

            this.formData.type.brandCode = this.brands.find(x => x.title.toLowerCase() === this.brandTitle.toLowerCase())?.brandCode;
        } else {
            this.suggestions = this.brands;
        }

        if (!this.formData.type.brandCode) {
            this.formData.type.modelYear = null;
            this.formData.type.modelCode = null;
            this.formData.type.typeCode = null;
            this.yearTitle = "";
            this.modelTitle = "";
            this.typeTitle = "";
        }
    }

    public setBrand(brand: any) {
        if (this.suggestionIndex !== -1) {
            brand = this.suggestions[this.suggestionIndex];
        }

        if (brand) {
            this.formData.type.brandCode = brand.brandCode;
            this.brandTitle = brand.title;

            this.formData.type.modelYear = null;
            this.formData.type.modelCode = null;
            this.formData.type.typeCode = null;
            this.yearTitle = "";
            this.modelTitle = "";
            this.typeTitle = "";
            this.resetSuggestionValues();
        }
    }

    public async setYearMenu() {
        await this.getYears();

        this.resetSuggestionValues();
        this.suggestionMode = "Year";

        this.formData.type.modelYear = null;

        if (this.yearTitle) {
            this.suggestions = this.years.filter(x => x.title.toLowerCase().startsWith(this.yearTitle.toLowerCase()));

            this.formData.type.modelYear = this.years.find(x => x.title.toLowerCase() === this.yearTitle.toLowerCase())?.value;
        } else {
            this.suggestions = this.years;
        }

        if (!this.formData.type.modelYear) {
            this.formData.type.modelCode = null;
            this.formData.type.typeCode = null;
            this.modelTitle = "";
            this.typeTitle = "";
        }
    }

    public setYear(year: any) {
        if (this.suggestionIndex !== -1) {
            year = this.suggestions[this.suggestionIndex];
        }

        if (year) {
            this.formData.type.modelYear = year.value;
            this.yearTitle = year.title;

            this.formData.type.modelCode = null;
            this.formData.type.typeCode = null;
            this.modelTitle = "";
            this.typeTitle = "";
            this.resetSuggestionValues();
        }
    }

    public async setModelMenu() {
        await this.getModels();

        this.resetSuggestionValues();
        this.suggestionMode = "Model";

        this.formData.type.modelCode = null;

        if (this.modelTitle) {
            this.suggestions = this.models.filter(x => x.title.toLowerCase().startsWith(this.modelTitle.toLowerCase()));

            this.formData.type.modelCode = this.models.find(x => x.title.toLowerCase() === this.modelTitle.toLowerCase())?.modelCode;
        } else {
            this.suggestions = this.models;
        }

        if (!this.formData.type.modelCode) {
            this.formData.type.typeCode = null;
            this.typeTitle = "";
        }
    }

    public setModel(model: any) {
        if (this.suggestionIndex !== -1) {
            model = this.suggestions[this.suggestionIndex];
        }

        if (model) {
            this.formData.type.modelCode = model.modelCode;
            this.modelTitle = model.title;

            this.formData.type.typeCode = null;
            this.typeTitle = "";
            this.resetSuggestionValues();
        }
    }

    public async setTypeMenu() {
        await this.getTypes();

        this.resetSuggestionValues();
        this.suggestionMode = "Type";

        this.formData.type.typeCode = null;

        if (this.typeTitle) {
            this.suggestions = this.types.filter(x => x.title.toLowerCase().startsWith(this.typeTitle.toLowerCase()));

            this.formData.type.typeCode = this.types.find(x => x.title.toLowerCase() === this.typeTitle.toLowerCase())?.typeCode;
        } else {
            this.suggestions = this.types;
        }
    }

    public setType(type: any) {
        if (this.suggestionIndex !== -1) {
            type = this.suggestions[this.suggestionIndex];
        }

        if (type) {
            this.formData.type.typeCode = type.typeCode;
            this.typeTitle = type.title;
            this.resetSuggestionValues();
        }
    }

    public setProductTypeMenu() {
        this.isProductTypeMenu = !this.isProductTypeMenu;
    }

    public async setCodeMenu() {
        if (this.formData.code.code?.length >= 3) {
            await this.getCodes();
        }

        this.resetSuggestionValues();
        this.suggestionMode = "Code";

        if (this.formData.code.code?.length >= 3) {
            this.suggestions = this.codes;
        }

        (this.formData.code.code?.length >= 3 && this.suggestions.length === 0) ? this.isReportCode = true : this.isReportCode = false;
        this.isReported = false;
    }

    public setCode(code: any) {
        if (this.suggestionIndex !== -1) {
            code = this.suggestions[this.suggestionIndex];
        }

        if (code) {
            GTagHelper.sendCustomEvent("view_search_results", { search_type: "code", veichle_type: "car", product_code: this.formData.code.code });
            window.location.href = code.url;
            this.isLoading = true;
        } else if (this.formData.code.code) {
            this.submitCodeForm();
        }
    }

    public resetBrand() {
        this.formData.type.brandCode = null;
        this.formData.type.modelYear = null;
        this.formData.type.modelCode = null;
        this.formData.type.typeCode = null;
        this.brandTitle = "";
        this.yearTitle = "";
        this.modelTitle = "";
        this.typeTitle = "";
    }

    public resetYear() {
        this.formData.type.modelYear = null;
        this.formData.type.modelCode = null;
        this.formData.type.typeCode = null;
        this.yearTitle = "";
        this.modelTitle = "";
        this.typeTitle = "";
    }

    public resetModel() {
        this.formData.type.modelCode = null;
        this.formData.type.typeCode = null;
        this.modelTitle = "";
        this.typeTitle = "";
    }

    public resetType() {
        this.formData.type.typeCode = null;
        this.typeTitle = "";
    }

    public reportCode() {
        GTagHelper.sendCustomEvent("click", { reportcode_car: this.formData.code.code });
        this.isReported = true;
    }

    public setProductTypes(e: any) {
        this.formData.type.productTypes = this.vehicleFilter.productTypes;

        if (e.target.value === "All") {
            this.formData.type.productTypes = this.formData.type.productTypes.length === 0 ? ["Disc"] : ["All"];
        } else if (e.target.value === "AddAftermarket") {
            this.formData.type.productTypes = this.formData.type.productTypes.concat(this.aftermarketList);
            this.formData.type.productTypes = [...new Set(this.formData.type.productTypes)];
        } else if (e.target.value === "AddUpgrade") {
            this.formData.type.productTypes = this.formData.type.productTypes.concat(this.upgradeList);
            this.formData.type.productTypes = [...new Set(this.formData.type.productTypes)];
        } else if (e.target.value === "LessAftermarket") {
            this.formData.type.productTypes = this.formData.type.productTypes.filter(x => !this.aftermarketList.includes(x));
        } else if (e.target.value === "LessUpgrade") {
            this.formData.type.productTypes = this.formData.type.productTypes.filter(x => !this.upgradeList.includes(x));
        } else {
            this.formData.type.productTypes = this.formData.type.productTypes.length === 0 ? ["All"] : this.formData.type.productTypes.filter(x => x !== "All");
        }

        if (this.region !== "america") {
            this.formData.type.productTypes = this.formData.type.productTypes.length === 0 ? ["All"] : this.formData.type.productTypes.filter(x => x !== "All");
        }

        this.checkSelectionActive();

        this.setProductTypeLabel();

        this.syncFilterData();
    }

    public checkSelectionActive() {
        this.isSelectingAllAftermarket = this.aftermarketList.every(item => this.formData.type.productTypes.includes(item)) ? false : true;
        this.isSelectingAllUpgrade = this.upgradeList.every(item => this.formData.type.productTypes.includes(item)) ? false : true;
    }

    public setProductTypeLabel() {
        const self = this;

        if (this.formData.type.productTypes[0] != "All") {
            this.formData.type.productTypes = this.formData.type.productTypes.filter(function (e) {
                return self.searchCarProductTypes.map(x => x.value).indexOf(e) > -1;
            });
        }

        if (!this.formData.type.productTypes.includes("All")) {
            this.selectedProductTypes = (this.searchCarProductTypes.filter(x => this.formData.type.productTypes.includes(x.value)).map(x => x.title).slice(0, 2)).join(", ");

            if (this.formData.type.productTypes.length === this.searchCarProductTypes.length) {
                this.selectedProductTypes = null;
            } else if (this.formData.type.productTypes.length > 2) {
                this.selectedProductTypes += " +" + (this.formData.type.productTypes.length - 2);
            }
        } else {
            this.selectedProductTypes = null;
        }
    }

    public syncFilterData() {
        let data = {
            vehicleType: "Car",
            productTypes: this.formData.type.productTypes,
            isSelectingAllAftermarket: this.isSelectingAllAftermarket,
            isSelectingAllUpgrade: this.isSelectingAllUpgrade,
            isUpgrade: this.region === "america" ? false : true,
            selectedProductTypes: this.selectedProductTypes
        }

        this.$emit("setFilterData", data);
    }

    public resetSuggestionValues() {
        this.suggestionIndex = -1;
        this.suggestions = [];
    }

    public async submitTypeForm() {
        this.validationErrors = [];

        try {
            const result = (await Axios.post(this.routes.CatalogueGlobalCarSearch_SearchType, this.formData.type, { headers: { "RequestVerificationToken": FormHelper.getRequestVerificationToken() } })).data;

            // Analytics
            var brand = this.brands.find(x => x.value === this.formData.type.brandCode).title;
            var model = this.models.find(x => x.value === this.formData.type.modelCode).title;
            var type = this.types.find(x => x.value === this.formData.type.typeCode).title;

            GTagHelper.sendCustomEvent("view_search_results", { search_type: "type", veichle_type: "car", product_application: brand + " " + model + " " + type });

            window.location.href = result.url;
        } catch (error) {
            if (error.response && error.response.status === 400) {
                this.validationErrors = FormHelper.getValidationErrors(error.response.data);
            }
        }
    }

    public async submitPlateForm() {
        FormHelper.removeFocus();
        this.validationErrors = [];
        this.isLoadingPlate = true;

        try {
            const result = (await Axios.post(this.routes.CatalogueGlobalCarSearch_SearchPlate, this.formData.plate, { headers: { "RequestVerificationToken": FormHelper.getRequestVerificationToken() } })).data;

            GTagHelper.sendCustomEvent("view_search_results", { search_type: "plate", veichle_type: "car", location: this.formData.plate.country, user_type: this.isUserAuthenticated ? "user" : "anonymous" });
            window.location.href = result.url;
        } catch (error) {
            if (error.response && error.response.status === 400) {
                this.validationErrors = FormHelper.getValidationErrors(error.response.data);
            } else if (error.response && error.response.status === 429) {
                if (error.response.data == "API calls quota exceeded! maximum admitted 100 per 1d.") {
                    this.validationErrors = FormHelper.getValidationErrors({ "Plate": [this.localizer.get("App.Common.SearchPlateLimitDailyReached")] });
                } else {
                    this.validationErrors = FormHelper.getValidationErrors({ "Plate": [this.localizer.get("App.Common.SearchPlateLimitReached")] });
                }
                this.isPlateError = true;
                setTimeout(x => {
                    this.validationErrors = [];
                    this.isPlateError = false;
                }, 10000);
            }
        }

        this.isLoadingPlate = false;
    }

    public async submitCodeForm() {
        FormHelper.removeFocus();
        this.validationErrors = [];

        try {
            const result = (await Axios.post(this.routes.CatalogueGlobalCarSearch_SearchCode, this.formData.code, { headers: { "RequestVerificationToken": FormHelper.getRequestVerificationToken() } })).data;
            GTagHelper.sendCustomEvent("view_search_results", { search_type: "code", veichle_type: "car", product_code: this.formData.code.code });
            window.location.href = result.url;
            this.isLoading = true;
        } catch (error) {
            if (error.response && error.response.status === 400) {
                this.validationErrors = FormHelper.getValidationErrors(error.response.data);
            }
        }
    }

    public async submitSizeForm() {
        FormHelper.removeFocus();
        this.validationErrors = [];

        this.formData.size.productType = this.vehicleFilter.productSize;

        if (this.formData.size.productType === 'Disc') this.formData.size.drumSize = {};
        if (this.formData.size.productType === 'Drum') this.formData.size.discSize = {};

        try {
            const result = (await Axios.post(this.routes.CatalogueGlobalCarSearch_SearchSize, this.formData.size, { headers: { "RequestVerificationToken": FormHelper.getRequestVerificationToken() } })).data;
            GTagHelper.sendCustomEvent("view_search_results", { search_type: "size", veichle_type: "car", product_type: this.formData.size.productType });
            window.location.href = result.url;
            this.isLoading = true;
        } catch (error) {
            if (error.response && error.response.status === 400) {
                this.validationErrors = FormHelper.getValidationErrors(error.response.data);
            }
        }
    }

    public suggestionMoveDown() {
        if (this.suggestions.length !== 0 && this.suggestionIndex < this.suggestions.length - 1) {
            this.suggestionIndex++;

            this.$nextTick(function () {
                this.checkIsInViewport();
            });
        }
    }

    public suggestionMoveUp() {
        if (this.suggestions.length !== 0 && this.suggestionIndex > 0) {
            this.suggestionIndex--;

            this.$nextTick(function () {
                this.checkIsInViewport();
            });
        }
    }

    public checkIsInViewport() {
        let myElement = document.querySelector(".search-result[data-selected='true']");
        let box = document.querySelector(".wrapper-result");

        const isInViewport = box.getBoundingClientRect().top >= 0 &&
            box.getBoundingClientRect().left >= 0 &&
            box.getBoundingClientRect().bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            box.getBoundingClientRect().right <= (window.innerWidth || document.documentElement.clientWidth);

        if (!myElement) { return; }

        if (!isInViewport) {
            (<any>myElement).scrollIntoView({ behavior: "smooth", block: "center" });
            return;
        }

        const isVisible = function (myElement, box) {
            const { bottom, height, top } = myElement.getBoundingClientRect();
            const containerRect = box.getBoundingClientRect();

            return top <= containerRect.top ? containerRect.top - top <= height : bottom - containerRect.bottom <= height;
        };

        if (!isVisible(myElement, box)) {
            (<any>myElement).scrollIntoView({ behavior: "smooth", block: "center" });
        }
    }

    public isValidationError(controlName: string): boolean {
        return FormHelper.isControlValidationError(controlName, this.validationErrors);
    }

    public formatApplicationDate(dateStart: string, dateEnd: string) {
        dateStart = dateStart != null ? dateStart : "-";
        dateEnd = dateEnd != null ? dateEnd : "-";

        let spanLeftArrow = "<span class=\"fastic-long-arrow-prev\"></span>";
        let spanRightArrow = "<span class=\"fastic-long-arrow-next\"></span>";

        if (dateStart.includes("<") || dateEnd.includes(">")) {
            return dateStart.replace("<", spanLeftArrow) + " " + dateEnd.replace(">", spanRightArrow);
        }

        if (dateStart.includes("-") || dateEnd.includes("-")) {
            return dateStart.replace("-", spanLeftArrow) + " " + dateEnd.replace("-", spanRightArrow);
        } else {
            return dateStart + " - " + dateEnd;
        }
    }
};